import React from 'react'
import { useHistory } from 'react-router'
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles'
import { Card, CardHeader, CardContent, CardActions } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import M_ButtonSearch from 'components/1_Atoms/2_Molecules/M_ButtonSearch'
import A_Message from 'components/1_Atoms/A_Message'
import TextField from '@material-ui/core/TextField'
import clsx from 'clsx'
import { useMediaQueryContext } from 'MediaQueryProvider'
import { useCreatePassword } from 'hooks/useLogin'

const WIDTH = 500
const WIDTH_MIN = 320
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      alignContent: 'center',
      alignItems: 'center',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: `${theme.spacing(0)} auto`,
    },
    header: {
      textAlign: 'center',
      background: '#212121',
      color: '#fff',
    },
    card: {
      width: WIDTH,
      marginTop: theme.spacing(10),
    },
    cardM: {
      width: WIDTH_MIN,
      marginTop: theme.spacing(10),
    },
  }),
)

const O_SearchBoxCreatePassword = ({ title }: { title: string }) => {
  const classes = useStyles()
  const { isMobileSite } = useMediaQueryContext()
  const history = useHistory()
  const [mail, changeMail, changed, click, message, messageColor, disabled] = useCreatePassword(history)

  return (
    <form className={classes.container} noValidate autoComplete="off">
      <Card className={clsx(classes.card, isMobileSite && classes.cardM)} onSubmit={click}>
        <CardHeader className={classes.header} title={title} />
        <CardContent>
          {changed ? null : (
            <div>
              <TextField
                key={1} //
                tabIndex={1}
                className={'input-numeric'}
                // type="number"
                inputProps={{ minLength: 0, maxLength: 90, pattern: '[0-9]' }}
                style={{ width: '100%' }}
                variant="outlined"
                value={mail}
                onChange={changeMail}
                onBlur={(e) => e.preventDefault()}
                autoFocus={true}
                placeholder="メールアドレスを入力してください。"
                size="small"
              />
            </div>
          )}
        </CardContent>
        <CardActions>
          <Grid container className={classes.root} justifyContent={'center'}>
            <Grid item xs={8}>
              <A_Message color={messageColor} message={message ? message : '　'} align={'center'} />
            </Grid>
            <Grid item xs={8}>
              <M_ButtonSearch label={changed ? '戻る' : '送信'} onClick={click} disabled={disabled} />
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </form>
  )
}
export default React.memo(O_SearchBoxCreatePassword)
